module.exports = __webpack_public_path__ + "img/ch67.b7979fa7.jpg";